export enum StatusMessageType {
  ERROR = "E",
  WARNING = "W",
}

export interface StatusMessage {
  code?: number;
  message: string;
  type?: StatusMessageType;
  year?: number;
  period?: number; // only has a value if year is defined
  courseCode?: string; // only has a value if period is defined
  examTypeDescription?: string;
  forElectives?: boolean; // validation message is related to profiling
}
